import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useCart } from '../../context/CartContext';

const navLinks = [
  { to: '/', label: 'Home', end: true },
  { to: '/our-story', label: 'Our Story' },
//   { href: '/#products', label: 'Products' },
  { to: '/how-to-make', label: 'How to Make' },
  { to: '/why-choose', label: 'Why Choose' },
  { to: '/reviews', label: 'Reviews' },
  { to: '/contact-us', label: 'Contact Us' },
];

export function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { count, setCartOpen } = useCart();
  return (
    <nav className="navbar">
      <Link to="/" className="navbar-brand">
        <img src="/logo.webp" alt="Kiane" className="navbar-logo" />
      </Link>
      <ul className={`nav-links${menuOpen ? ' open' : ''}`}>
        {navLinks.map(l => (
          <li key={l.label}>
            {l.to
              ? (
                <NavLink
                  to={l.to}
                  end={l.end}
                  onClick={() => setMenuOpen(false)}
                  className={({ isActive }) => isActive ? 'nav-active' : undefined}
                >
                  {l.label}
                </NavLink>
              )
              : <a href={l.href} onClick={() => setMenuOpen(false)}>{l.label}</a>
            }
          </li>
        ))}
      </ul>
      <div className="navbar-right">
        <button className="cart-nav-btn" onClick={() => setCartOpen(true)} aria-label="Open cart">
          🛒
          {count > 0 && <span className="cart-nav-count">{count}</span>}
        </button>
        <button className="nav-toggle" aria-label="Toggle menu" onClick={() => setMenuOpen(!menuOpen)}>
          <span /><span /><span />
        </button>
      </div>
    </nav>
  );
}
